import { PapirflyLanguage } from "./PapirflyLanguage";

export class PapirflySettings {
  id?: number;
  server?: string;
  companyId?: string;
  archiveSelector?: string;
  languageId?: PapirflyLanguage;
  defaultServer?: string;
  defaultLanguageId?: PapirflyLanguage;
  
  get resolvedLanguageId(): PapirflyLanguage | null {
    return this.languageId ?? this.defaultLanguageId;
  };

  get resolvedServer(): string | null {
    return this.server ?? this.defaultServer;
  };

  constructor(
    id?: number,
    server?: string,
    companyId?: string,
    archiveSelector?: string,
    languageId?: number,
    defaultServer?: string,
    defaultLanguageId?: PapirflyLanguage,
  ) {
    this.id = id;
    this.server = server;
    this.companyId = companyId;
    this.archiveSelector = archiveSelector;
    this.languageId = languageId;
    this.defaultServer = defaultServer;
    this.defaultLanguageId = defaultLanguageId;
  }

  get isConfigured(): boolean {
    return (
      this.resolvedServer != null &&
      this.resolvedServer.trim() != '' &&
      this.companyId != null &&
      this.companyId.trim() != ''
    );
  }
}
